// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"c89c4491","533":"4d31a616","669":"c89c4491","859":"c89c4491"}[chunkId] + ".chunk.css";
};